import { EventEmitter } from '@angular/core';
var ChipComponent = (function () {
    function ChipComponent() {
        this.selected = false;
        this.select = new EventEmitter();
    }
    ChipComponent.prototype.ngOnInit = function () {
    };
    ChipComponent.prototype.onclick = function (btn) {
        this.select.emit(this);
    };
    return ChipComponent;
}());
export { ChipComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chip/chip.component.ts.pre-build-optimizer.js